import { ToasterProps } from "sonner"

const defaultTaostConfig: ToasterProps  = {
  position: "top-center",
  richColors: true,
  // invertColors: true,
  // theme: "light",
}

export default defaultTaostConfig